import { render, staticRenderFns } from "./creat_time.vue?vue&type=template&id=200b14f3&scoped=true&"
import script from "./creat_time.vue?vue&type=script&lang=js&"
export * from "./creat_time.vue?vue&type=script&lang=js&"
import style0 from "./creat_time.vue?vue&type=style&index=0&id=200b14f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b14f3",
  null
  
)

export default component.exports